import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, OnInit, HostListener, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppSidebarComponent implements OnInit, OnDestroy {
    @HostBinding('class') string = 'eui-app-sidebar';

    private windowResizedSubscription: Subscription;

    constructor(
        public asService: UxAppShellService,
    ) {
        this.windowResizedSubscription = fromEvent(window, 'resize')
            .pipe(
                debounceTime(300),
            )
        .subscribe((event: Event) => {
            this._closeMobileSidebar();
        });
    }

    @HostListener('body:click')
    close() {
        if (this.asService.state.breakpoints.isMobile
            || this.asService.state.breakpoints.isTablet
            || this.asService.state.isSidebarHidden) {
            this.asService.isSidebarOpen = false;
        }
    }

    ngOnInit() {
        this.asService.activateSidebar();
        this._closeMobileSidebar();
    }

    ngOnDestroy() {
        if (this.windowResizedSubscription) {
            this.windowResizedSubscription.unsubscribe();
        }
    }

    onMouseEnter(event: any) {
        this.asService.isSidebarHover = true;
    }

    onMouseLeave(event: any) {
        this.asService.isSidebarHover = false;
    }

    private _closeMobileSidebar() {
        if (this.asService.state.breakpoints.isMobile
            || this.asService.state.breakpoints.isTablet) {
            this.asService.isSidebarOpen = false;
        }
    }
}
